import type GameSet from "../../GameSet";
import type { Assignment } from "./types";

export function applyAssignment(gameSet: GameSet, assignment: Assignment): void {
  for (const entry of assignment.games) {
    const game = gameSet.unlockedGames.find((g) => g.index === entry.gameIndex);
    if (!game) continue;
    game.playerIds = entry.slots;
  }
}
